import styled from 'styled-components'

export const Container = styled.div`
  width: 90%;
  max-width: 1300px;
  border-radius: 13px;
  background: #1a1a1a;
  padding: 1.5rem;
  margin: 90px auto 0;

  @media only screen and (min-width: 1090px) {
    margin-top: 130px;
  }
`

export const ContentWrapper = styled.div`
  h2 {
    font-size: 1.275rem;
    line-height: 1.8675rem;
    font-weight: 700;
    color: #fff;
    margin: 0.5rem 2rem 0.5rem 0;
    max-width: 578px;
  }

  p {
    font-size: 1;
    line-height: 2rem;
    font-weight: 400;
    color: #bababa;
    margin: 0.5rem 4rem 1rem 0;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    a,
    button {
      font-size: 0.875rem;
      line-height: 1rem;
      font-weight: 600;
      max-width: 148px;
      color: #fff;
      background: #ff6600;
      padding: 0.6875rem 1.2rem;
      border: none;
      border-radius: 4px;
    }

    .mobile {
      position: relative;
      margin: -10rem -4rem -1.5rem auto;
      width: auto;
      height: 200px;

      @media only screen and (min-width: 1090px) {
        display: none;
      }
    }
  }

  .desktop {
    position: relative;
    margin: -4rem -5rem -1.5rem 0;
    width: auto;
    height: 220px;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);

    @media only screen and (max-width: 1090px) {
      display: none;
    }
  }

  @media only screen and (min-width: 1090px) {
    display: grid;
    grid-template-columns: 0.1fr 2fr 0.3fr;

    h2 {
      font-size: 1.625rem;
      line-height: 1.9375rem;
    }

    p {
      max-width: 500px;
      font-size: 1rem;
      line-height: 1.9375rem;
    }

    div {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      button {
        margin-right: 3rem;
        min-width: 148px;
      }
    }
  }
`
